import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaMeta } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa6";
import { FaApple } from "react-icons/fa6";

const SsoComponent = () => {
    const baseUrl = process.env.REACT_APP_API_URL;
    const handleRedirect = (url) => {
        window.location.href = url;
    };
    return(
        <Row className={'text-center sso-row'}>
            <Col className="d-flex justify-content-center align-items-center">
                <button disabled className='sso-icon d-flex justify-content-center align-items-center'>
                    <FaApple />
                </button>
            </Col>
            <Col className="d-flex justify-content-center align-items-center">
                <button onClick={() => handleRedirect(baseUrl + '/auth/redirect/google')} className='sso-icon d-flex justify-content-center align-items-center'>
                    <FaGoogle />
                </button>
            </Col>
            <Col className="d-flex justify-content-center align-items-center">
                <button disabled className='sso-icon d-flex justify-content-center align-items-center'>
                    <FaMeta />
                </button>
            </Col>
        </Row>
    )
}

export default SsoComponent;